import {createRouter, RouterProvider} from "@tanstack/react-router"
import {routeTree} from "@/gen/routes"
import {useCallback, useEffect, useState} from "react"
import {AppContext} from "@/context/AppContext"
import * as Sentry from "@sentry/react";

const router = createRouter({
  routeTree,
  scrollRestoration: false,
})

declare module "@tanstack/react-router" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router;
  }
}


export function AppRouterProvider() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769) // Special check for mobile mode, to change html structure

  useCallback(()=>{
    Sentry.addIntegration(Sentry.tanstackRouterBrowserTracingIntegration(router))
  },[])

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      setIsMobile(width < 769)
    }

    handleResize() // initial
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <AppContext.Provider value={{isMobile}}>
      <RouterProvider router={router}/>
    </AppContext.Provider>
  )
}
